var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mapbox',{attrs:{"access-token":_vm.mapboxKey,"map-options":_vm.mapOptions,"geolocate-control":{
    show: true,
    position: 'top-left'
  }}})}
var staticRenderFns = []

export { render, staticRenderFns }